export default __webpack_public_path__ + "static/media/Honorarios_planilla_de_cirugias.0a28e19a.xlsx";